<button mat-button class="custom-button" [ngClass]="customClass" [ngStyle]="customStyle" [disabled]="disabled" (click)="handleClick($event)">
  <ng-content></ng-content>
</button>
